import { Directive, Input, HostBinding, OnInit } from "@angular/core";

@Directive({
	selector: "[ngbTooltip]",
})
export class AccessKeyDirective implements OnInit {
	@Input() ngbTooltip: string;

	@HostBinding("attr.accesskey") accesskey: string;

	constructor() {}

	ngOnInit(): void {
		switch (this.ngbTooltip) {
			case "Edit":
				this.accesskey = "e";
				break;
			case "Help":
				this.accesskey = "h";
		}
	}
}
